import { FaFacebookF } from "react-icons/fa";
import { useAPI } from "../Context/MyContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useState } from "react";

function FacebookLogin() {
  const { loginWithFacebook, completeProfile } = useAPI();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFacebookLogin = () => {
    if (!window.FB) {
      console.error("❌ Facebook SDK not loaded yet");
      return;
    }

    window.FB.login(
      (response) => {
        if (response.authResponse) {
          window.FB.api("/me", { fields: "id,name,email,picture" }, async () => {
            try {
              const res = await loginWithFacebook({
                accessToken: response.authResponse.accessToken,
              });

              console.log("✅ Backend Response:", res);

          

              // Handle inactive account
              if (res.code === "ACCOUNT_INACTIVE") {
                toast.error(res.message || "Account is inactive");
                return navigate("/inactive");
              }

              // Handle expired subscription
              if (res.code === "PLAN_EXPIRED") {
                toast.error(res.message || "Subscription expired");
                return navigate("/subscription-expired");
              }


              if (res.success) {
                if (res.requiresEmail) {
                  setToken(res.token); // 👈 store token temporarily
                  setShowModal(true); // 👈 open modal
                }

                else {
                  navigate("/dashboard");
                }
              }
            } catch (error) {
              toast.error(error.message || "Facebook login failed");
            }
          });
        }
      },
      {
        scope: "email,public_profile,whatsapp_business_management",
        auth_type: "rerequest",
        return_scopes: true,
      }
    );
  };

  // 👉 Submit email
  const handleCompleteProfile = async () => {
    if (!email) {
      return toast.error("Email is required");
    }

    setLoading(true);
    try {
      const res = await completeProfile({ email, token });


      console.log("Complete Profile Response:", res);
      // ❗ Handle inactive again (edge case)
      if (res.code === "ACCOUNT_INACTIVE") {
        toast.error(res.message || "Account is inactive");
        setShowModal(false);
        return navigate("/inactive");
      }

      if (res.success) {
        toast.success("Profile completed!");
        setShowModal(false);
        navigate("/dashboard");
      }
    } catch (err) {
      toast.error(err.message || "Failed to complete profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Facebook Button */}
      <button
        type="button"
        onClick={handleFacebookLogin}
        className="w-full flex items-center justify-center gap-3 bg-[#1877F2] hover:bg-[#166FE5] text-white font-semibold py-3.5 px-4 rounded-lg"
      >
        <FaFacebookF />
        Continue with Facebook
      </button>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-[90%] max-w-md shadow-xl">
            <h2 className="text-xl font-semibold mb-2">
              Complete Your Profile
            </h2>

            <p className="text-sm text-gray-500 mb-4">
              We couldn’t get your email from Facebook. Please enter it to continue.
            </p>

            <input
              type="email"
              placeholder="Enter your email"
              className="w-full border rounded-lg px-3 py-2 mb-4 outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className="flex gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="w-full py-2 border rounded-lg"
              >
                Cancel
              </button>

              <button
                onClick={handleCompleteProfile}
                disabled={loading}
                className="w-full py-2 bg-blue-600 text-white rounded-lg"
              >
                {loading ? "Saving..." : "Continue"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FacebookLogin;